module.exports = __webpack_public_path__ + "images/hero-image@2x.2a3a4c392655a9508ca6c0a252ebbf8f.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/hero-image@2x.jpg
// module id = 1005
// module chunks = 0